export function Logo({ size = "md", light = false, className = "" }) {
  const dims = {
    sm: { img: "w-12 h-12", t1: "text-[11px] tracking-[0.3em]", t2: "text-2xl", gap: "gap-2.5" },
    md: { img: "w-16 h-16", t1: "text-xs tracking-[0.3em]", t2: "text-3xl", gap: "gap-3" },
    lg: { img: "w-36 h-36", t1: "text-xl tracking-[0.3em]", t2: "text-7xl", gap: "gap-5" },
  }[size];
  return (
    <div className={`flex items-center ${dims.gap} ${className}`} data-testid="app-logo">
      <img src="/mascot.png" alt="Maskot Bimbel Gemma" className={`${dims.img} object-contain drop-shadow-md shrink-0`} />
      <div className="leading-none">
        <div className={`font-display font-bold uppercase ${dims.t1} ${light ? "text-white" : "text-orange-500"}`}>Bimbel</div>
        <div className={`font-display font-black tracking-tight -mt-0.5 ${dims.t2} ${light ? "text-white drop-shadow-sm" : "text-[#1e2a78]"}`}>GEMMA</div>
      </div>
    </div>
  );
}
